import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { some } from 'lodash';
import { theme as antdTheme } from '@timeedit/ui-components/antd';

interface GlobalFieldRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string;
  searchString: string;
}

const GlobalFieldRow = ({ searchString, ...props }: GlobalFieldRowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  });
  const { useToken } = antdTheme;
  const { token } = useToken();

  const field = props.children[0]?.props?.record;
  const isHighlighted = searchString
    ? some([field.name.toLowerCase(), field.extId.toLowerCase()], (str) =>
        str.includes(searchString.toLowerCase())
      )
    : false;

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: 'move',
    backgroundColor: isHighlighted ? token.green3 : 'inherit',
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  return (
    <tr
      {...props}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    />
  );
};

export default GlobalFieldRow;
